export default function BudgetIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width="18"
        height="18"
        x="0"
        y="0"
        viewBox="0 0 60 60"
      >
        <g>
          <path
            d="M6 45c0 13.842 11.856 15 24 15s24-1.158 24-15c0-13.454-9.773-21.519-14.3-24.533A3 3 0 0 0 38 15h-.35l2.8-5.36a4.346 4.346 0 0 0 .29-3.616 4.121 4.121 0 0 0-2.4-2.457 8.817 8.817 0 0 0-2.7-.55A6.169 6.169 0 0 0 30 0a6.169 6.169 0 0 0-5.627 3.017 8.83 8.83 0 0 0-2.705.55 4.122 4.122 0 0 0-2.4 2.457 4.332 4.332 0 0 0 .275 3.59L22.35 15H22a3 3 0 0 0-1.7 5.467C15.773 23.481 6 31.546 6 45ZM21.3 8.663a2.346 2.346 0 0 1-.155-1.954 2.091 2.091 0 0 1 1.231-1.271 6.724 6.724 0 0 1 1.814-.4l.83 4.162a1 1 0 0 0 .98.8.955.955 0 0 0 .2-.02 1 1 0 0 0 .78-1.18l-.935-4.677A4.19 4.19 0 0 1 30 2a4.19 4.19 0 0 1 3.955 2.126L33.02 8.8a1 1 0 0 0 .78 1.18.948.948 0 0 0 .2.02 1 1 0 0 0 .979-.8l.832-4.159a6.717 6.717 0 0 1 1.813.4 2.09 2.09 0 0 1 1.232 1.271 2.362 2.362 0 0 1-.169 1.979L35.394 15H24.606ZM22 17h16a1 1 0 0 1 0 2H22a1 1 0 0 1 0-2Zm1.25 4h13.5c1.8.985 15.25 8.845 15.25 24 0 10.929-7.732 13-22 13S8 55.929 8 45c0-15.155 13.447-23.015 15.25-24Z"
            fill="#000000"
            opacity="1"
            data-original="#000000"
          ></path>
          <path
            d="M29 40.786v7.158a6.8 6.8 0 0 1-4.32-1.863 1 1 0 0 0-1.487 1.338A8.79 8.79 0 0 0 29 49.957V52a1 1 0 0 0 2 0v-2.045c4-.33 7-2.6 7-5.455 0-3.349-3.571-4.443-7-5.286v-7.158a6.8 6.8 0 0 1 4.32 1.863 1 1 0 0 0 1.487-1.338A8.79 8.79 0 0 0 31 30.043V28a1 1 0 0 0-2 0v2.045c-4 .33-7 2.6-7 5.455 0 3.349 3.571 4.443 7 5.286Zm7 3.714c0 1.7-2.2 3.158-5 3.445v-6.667c3.06.785 5 1.553 5 3.222Zm-7-12.445v6.667c-3.06-.785-5-1.553-5-3.222 0-1.7 2.205-3.158 5-3.445Z"
            fill="#000000"
            opacity="1"
            data-original="#000000"
          ></path>
        </g>
      </svg>
    </>
  );
}
